import { ADMIN_TYPES } from "services/types";
import { init, success, finish, error } from "services/common";
import { message } from "antd";
import { SowAbbrService } from "./api"; // Import the SowAbbrService

const sowAbbrService = new SowAbbrService(); // Initialize the SowAbbrService

// Action for fetching paginated SowAbbr list
export const getSowAbbrPaginationListNew = (body, searchQuery = "") => {
  return async (dispatch) => {
    dispatch(init(ADMIN_TYPES.SOW_ABBR_PAGINATION));

    // Modify the API call to include the searchQuery
    const response = await sowAbbrService.getSowAbbrPaginationListNew({
      ...body, // Include any existing params
      Abbr: searchQuery, // Add the search query parameter
    });

    if (response.isSuccess) {
      dispatch(success(ADMIN_TYPES.SOW_ABBR_PAGINATION, response.data));
    } else if (!response.isSuccess) {
      dispatch(error(response.errorMessage));
    }

    dispatch(finish(ADMIN_TYPES.SOW_ABBR_PAGINATION));
  };
};

// Action for adding a new SowAbbr entry
export const actionForAddSowAbbr = (body, callback) => {
  return async (dispatch) => {
    dispatch(init(ADMIN_TYPES.SOW_ABBR_ADD)); // Initialize the add action
    const response = await sowAbbrService.createSowAbbr(body); // Call the service method
    if (response.isSuccess) {
      dispatch(success(ADMIN_TYPES.SOW_ABBR_ADD, response.data)); // Dispatch success
      message.success("Added SowAbbr Successfully"); // Show success message

      // Call the callback to close the drawer
      if (callback) callback();
    } else {
      dispatch(error(response.errorMessage)); // Dispatch error message
    }
    dispatch(finish(ADMIN_TYPES.SOW_ABBR_ADD)); // Finish the add action
  };
};

// Action for updating an existing SowAbbr entry
export const actionForUpdateSowAbbr = (body, callback) => {
  return async (dispatch) => {
    dispatch(init(ADMIN_TYPES.SOW_ABBR_UPDATE)); // Initialize the update action
    const response = await sowAbbrService.updateSowAbbr(body); // Call the service method
    if (response.isSuccess) {
      dispatch(success(ADMIN_TYPES.SOW_ABBR_UPDATE, response.data)); // Dispatch success
      message.success("Updated SowAbbr Successfully"); // Show success message

      // Call the callback to close the drawer
      if (callback) callback();
    } else {
      dispatch(error(response.errorMessage)); // Dispatch error message
    }
    dispatch(finish(ADMIN_TYPES.SOW_ABBR_UPDATE)); // Finish the update action
  };
};

// Action for fetching details of a specific SowAbbr entry by ID
export const getSowAbbrDetails = (id) => {
  return async (dispatch) => {
    dispatch(init(ADMIN_TYPES.SOW_ABBR_DETAILS)); // Initialize the details action
    const response = await sowAbbrService.getSowAbbrDetails(id); // Call the service method
    if (response.isSuccess) {
      dispatch(success(ADMIN_TYPES.SOW_ABBR_DETAILS, response.data)); // Dispatch success with the details
    } else if (!response.isSuccess) {
      dispatch(error(response.errorMessage)); // Dispatch error message
    }
    dispatch(finish(ADMIN_TYPES.SOW_ABBR_DETAILS)); // Finish the details action
  };
};
